import React from "react";
import Header from "../Header";

import { StyledModal } from "./styles";

const ModalMacros = ({
  title,
  onCancel,
  open,
  onOk,
  children,
  footer,
  isLoading,
  loading,
  noBottom,
  ...rest
}) => (
  <StyledModal
    title={<Header title={title} />}
    onCancel={onCancel}
    open={open}
    onOk={onOk}
    footer={footer}
    loading={isLoading || loading}
    noBottom={noBottom}
    {...rest}
  >
    {children}
  </StyledModal>
);

export default ModalMacros;
